<template>
    <span v-bind:class="item.class" @click="item.function(item.rowIndex, item.values)">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" v-tooltip="this.$t('status.delete')"
             width="24" height="24"
             viewBox="0 0 172 172"
             style=" fill:#000000; cursor: pointer;">
        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
           stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
           font-family="none" font-weight="none" font-size="none" text-anchor="none"
           style="mix-blend-mode: normal">
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g fill="#275cbb">
                <path
                        d="M71.66667,14.33333l-7.16667,7.16667h-35.83333v14.33333h7.16667v107.5c0,7.83362 6.49972,14.33333 14.33333,14.33333h57.33333v-14.33333h-57.33333v-107.5h71.66667v71.66667h14.33333v-71.66667h7.16667v-14.33333h-7.16667h-28.66667l-7.16667,-7.16667zM64.5,50.16667v78.83333h14.33333v-78.83333zM93.16667,50.16667v78.83333h14.33333v-78.83333zM128.13216,121.32943l-10.13411,10.13411l15.20117,15.20117l-15.20117,15.20117l10.13411,10.13411l15.20117,-15.20117l15.20117,15.20117l10.13411,-10.13411l-15.20117,-15.20117l15.20117,-15.20117l-10.13411,-10.13411l-15.20117,15.20117z"></path>
            </g>
        </g>
    </svg>
    </span>
</template>
<script>
    export default {
        name: 'TableTypeDeleteBtn',
        props: ['item']
    }
</script>